/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/location.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Location
 */
export interface Location {
    /**
     * @generated from protobuf field: optional string country_code = 1;
     */
    country_code?: string;
    /**
     * @generated from protobuf field: optional string dma = 2;
     */
    dma?: string;
    /**
     * TODO: rename zip_code to postal_code in airtable
     *
     * @generated from protobuf field: optional string postal_code = 3;
     */
    postal_code?: string;
    /**
     * @generated from protobuf field: optional string state = 4;
     */
    state?: string;
    /**
     * @generated from protobuf field: optional string province = 5;
     */
    province?: string;
    /**
     * @generated from protobuf field: optional string language = 6;
     */
    language?: string;
    /**
     * @generated from protobuf field: optional string timezone = 7;
     */
    timezone?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Location$Type extends MessageType<Location> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Location", [
            { no: 1, name: "country_code", kind: "scalar", localName: "country_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "USA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ISO 3166-1 alpha-3 codes for countries." } },
            { no: 2, name: "dma", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "501", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "DMA (Designated Market Area)." } },
            { no: 3, name: "postal_code", kind: "scalar", localName: "postal_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "77379", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Postal Code for some countries." } },
            { no: 4, name: "state", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "France", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "State." } },
            { no: 5, name: "province", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Province." } },
            { no: 6, name: "language", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "EN", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Language." } },
            { no: 7, name: "timezone", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timezone." } }
        ]);
    }
    create(value?: PartialMessage<Location>): Location {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Location>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Location): Location {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string country_code */ 1:
                    message.country_code = reader.string();
                    break;
                case /* optional string dma */ 2:
                    message.dma = reader.string();
                    break;
                case /* optional string postal_code */ 3:
                    message.postal_code = reader.string();
                    break;
                case /* optional string state */ 4:
                    message.state = reader.string();
                    break;
                case /* optional string province */ 5:
                    message.province = reader.string();
                    break;
                case /* optional string language */ 6:
                    message.language = reader.string();
                    break;
                case /* optional string timezone */ 7:
                    message.timezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Location, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string country_code = 1; */
        if (message.country_code !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.country_code);
        /* optional string dma = 2; */
        if (message.dma !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.dma);
        /* optional string postal_code = 3; */
        if (message.postal_code !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.postal_code);
        /* optional string state = 4; */
        if (message.state !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.state);
        /* optional string province = 5; */
        if (message.province !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.province);
        /* optional string language = 6; */
        if (message.language !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.language);
        /* optional string timezone = 7; */
        if (message.timezone !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.timezone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Location
 */
export const Location = new Location$Type();
